import { protectedRoute } from "@/lib/protectedRoute";
import { Templates } from "@/pages/Templates";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/templates")({
  component: Templates,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
